import { render, staticRenderFns } from "./StatistiqueReservationParGareTransport.vue?vue&type=template&id=22c1a778&scoped=true"
import script from "./StatistiqueReservationParGareTransport.vue?vue&type=script&lang=js"
export * from "./StatistiqueReservationParGareTransport.vue?vue&type=script&lang=js"
import style0 from "./StatistiqueReservationParGareTransport.vue?vue&type=style&index=0&id=22c1a778&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c1a778",
  null
  
)

export default component.exports